export enum Permission {
  Admin = 'ADMIN',
  DealManager = 'DEAL_MANAGER',
  Manager = 'MANAGER',
  Sales = 'SALES',
  SalesTools = 'SALES_TOOLS',
  SalesView = 'SALES_VIEW',
}
